import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import React, { forwardRef } from 'react';
import { useComponentDefaultProps } from '@mantine/styles';
import { packSx } from '@mantine/utils';
import { FLEX_SYSTEM_PROPS } from './flex-props.js';
import { Box } from '../Box/Box.js';
import { getSystemStyles } from '../Box/style-system-props/get-system-styles/get-system-styles.js';
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;

var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};

var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }

  if (__getOwnPropSymbols) {
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = __getOwnPropSymbols(b)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var prop = _step.value;
        if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
          _iterator["return"]();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
  }

  return a;
};

var __spreadProps = function __spreadProps(a, b) {
  return __defProps(a, __getOwnPropDescs(b));
};

var __objRest = function __objRest(source, exclude) {
  var target = {};

  for (var prop in source) {
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  }

  if (source != null && __getOwnPropSymbols) {
    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;

    try {
      for (var _iterator2 = __getOwnPropSymbols(source)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
        var prop = _step2.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _didIteratorError2 = true;
      _iteratorError2 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion2 && _iterator2["return"] != null) {
          _iterator2["return"]();
        }
      } finally {
        if (_didIteratorError2) {
          throw _iteratorError2;
        }
      }
    }
  }

  return target;
};

var defaultProps = {};
var Flex = forwardRef(function (props, ref) {
  var _a = useComponentDefaultProps("Flex", defaultProps, props),
      gap = _a.gap,
      rowGap = _a.rowGap,
      columnGap = _a.columnGap,
      align = _a.align,
      justify = _a.justify,
      wrap = _a.wrap,
      direction = _a.direction,
      sx = _a.sx,
      others = __objRest(_a, ["gap", "rowGap", "columnGap", "align", "justify", "wrap", "direction", "sx"]);

  return (
    /* @__PURE__ */
    React.createElement(Box, __spreadProps(__spreadValues({}, others), {
      sx: [{
        display: "flex"
      }, function (theme) {
        return getSystemStyles({
          gap: gap,
          rowGap: rowGap,
          columnGap: columnGap,
          align: align,
          justify: justify,
          wrap: wrap,
          direction: direction
        }, theme, FLEX_SYSTEM_PROPS);
      }].concat(_toConsumableArray(packSx(sx))),
      ref: ref
    }))
  );
});
Flex.displayName = "@mantine/core/Flex";
export { Flex };